import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedErrorRed = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 30,
	height: 29,
	viewBox: "0 0 30 29",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M15 20.4375C15.3365 20.4375 15.6185 20.3237 15.8461 20.0961C16.0737 19.8685 16.1875 19.5865 16.1875 19.25C16.1875 18.9135 16.0737 18.6315 15.8461 18.4039C15.6185 18.1763 15.3365 18.0625 15 18.0625C14.6635 18.0625 14.3815 18.1763 14.1539 18.4039C13.9263 18.6315 13.8125 18.9135 13.8125 19.25C13.8125 19.5865 13.9263 19.8685 14.1539 20.0961C14.3815 20.3237 14.6635 20.4375 15 20.4375ZM13.8125 15.6875H16.1875V8.5625H13.8125V15.6875ZM15 26.375C13.3573 26.375 11.8135 26.0633 10.3688 25.4398C8.92396 24.8164 7.66719 23.9703 6.59844 22.9016C5.52969 21.8328 4.68359 20.576 4.06016 19.1313C3.43672 17.6865 3.125 16.1427 3.125 14.5C3.125 12.8573 3.43672 11.3135 4.06016 9.86875C4.68359 8.42396 5.52969 7.16719 6.59844 6.09844C7.66719 5.02969 8.92396 4.18359 10.3688 3.56016C11.8135 2.93672 13.3573 2.625 15 2.625C16.6427 2.625 18.1865 2.93672 19.6313 3.56016C21.076 4.18359 22.3328 5.02969 23.4016 6.09844C24.4703 7.16719 25.3164 8.42396 25.9398 9.86875C26.5633 11.3135 26.875 12.8573 26.875 14.5C26.875 16.1427 26.5633 17.6865 25.9398 19.1313C25.3164 20.576 24.4703 21.8328 23.4016 22.9016C22.3328 23.9703 21.076 24.8164 19.6313 25.4398C18.1865 26.0633 16.6427 26.375 15 26.375Z",
		fill: "url(#paint0_linear_18511_5913)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_18511_5913",
		x1: 3.00003,
		y1: 26.6875,
		x2: 31.0097,
		y2: 8.48124,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#EB214D" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#EB214D"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#FBBECB"
			})
		]
	}) })]
});
export default SvgExtendedErrorRed;
